enum GeneralQueries {
  SsoLogin = 'ssoLogin',
  Login = 'login',
  Logout = 'logout',
  ForgotPassword = 'forgotPassword',
  ResetPassword = 'resetPassword',
  VerifyUserInvite = 'verifyUserInvite',
  RegisterUser = 'registerUser',
  ChangePassword = 'changePassword',
  UpdateUserDetails = 'updateUserDetails',
  EnrollMfa = 'enrollMfa',
  VerifyMfa = 'verifyMfa',
  UnenrollMfa = 'unenrollMfa',
  GenerateBackupCodes = 'generateBackupCodes',
  ConfirmBackupCodes = 'confirmBackupCodes',
  MfaLoginVerify = 'mfaLoginVerify',
  MfaLoginRecovery = 'mfaLoginRecovery'
}

enum UserQueries {
  Dashboard = 'dashboard',
  GetUserPurchases = 'getUserPurchases',
  GetUserPendingOPRPurchases = 'GetUserPendingOPRPurchases',
  GetUserOngoingPurchases = 'getUserOngoingPurchases',
  ToggleUserNotificationSettings = 'setUserEmailSettings',
  GetUserReimbursements = 'getUserReimbursements',
  AddPurchase = 'addPurchase',
  RequestPurchaseEligibility = 'requestPurchaseEligibility',
  InvalidatePurchase = 'invalidatePurchase',
  GetDepositAccount = 'getDepositAccount',
  AddDepositAccount = 'addDepositAccount',
  GetPurchaseAccounts = 'getPurchaseAccounts',
  GeneratePlaidToken = 'generatePlaidToken',
  CreatePurchaseAccountAuthLink = 'createPurchaseAccountAuthLink',
  ExtendConnection = 'extendConnection',
  AddPurchaseAccount = 'addPurchaseAccount',
  RemovePurchaseAccount = 'removePurchaseAccount',
  RemovePurchaseAccountConnection = 'removePurchaseAccountConnection',
  RelinkPurchaseAccount = 'relinkPurchaseAccount',
  UpdatePlaidLinkToken = 'updatePlaidLinkToken',
  AddPlaidError = 'addPlaidError',
  GetConnectAccountLinkUrl = 'getConnectAccountLinkUrl',
  GetResolveRequirementsLinkUrl = 'getResolveRequirementsLinkUrl'
}

enum EmployerQueries {
  EmployerDashboard = 'employerDashboard',
  GetInvoices = 'getInvoices',
  UsersForEmployer = 'usersForEmployer',
  InviteUser = 'inviteUser',
  BulkMetadataUpload = 'bulkMetadataUpload',
  DownloadMetadataTemplate = 'downloadMetadataTemplate',
  UsersWithMetadata = 'usersWithMetadata',
  CancelUserInvite = 'cancelUserInvite',
  RemoveUser = 'removeUser',
  ReinviteUser = 'reinviteUser',
  GrantUserAdminPermissions = 'grantUserAdminPermissions',
  RevokeUserAdminPermissions = 'revokeUserAdminPermissions',
  AddUserToPrograms = 'addUserToPrograms',
  RemoveUserFromProgram = 'removeUserFromProgram',
  GetPaymentMethods = 'getPaymentMethods',
  ToggleAutopay = 'toggleAutopay',
  SubmitInvoicePayment = 'submitInvoicePayment',
  RemovePaymentMethod = 'removePaymentMethod',
  DownloadInvoice = 'downloadInvoice',
  GetAppVersion = 'getAppVersion',
  GetStripeSetupIntentToken = 'getStripeSetupIntentToken',
  EmployerBenefitPrograms = 'getEmployerBenefitPrograms',
  BenefitProgramUtilization = 'getBenefitProgramUtilization',
  EmployerReceiptsDownload = 'employerReceiptsDownload',
  EmployerMetaFields = 'employerMetaFields'
}

enum JOONAdminQueries {
  GetEmployers = 'getEmployers',
  GetEmployerDetails = 'getEmployerDetails',
  GetAdminInvoices = 'getAdminInvoices',
  AddInvoice = 'addInvoice',
  DeleteInvoice = 'deleteInvoice',
  FinalizeInvoice = 'finalizeInvoice',
  RevertInvoiceToDraft = 'revertInvoiceToDraft',
  RunInvoiceAutopay = 'runInvoiceAutopay',
  AssociateStripeInvoice = 'associateStripeInvoice',
  GetInvoiceDetails = 'getInvoiceDetails',
  ResetLogin = 'resetLogin',
  DownloadBenefitRecipientsOverviewReport = 'downloadBenefitRecipientsOverviewReport',
  DownloadPurchasesReport = 'downloadPurchasesReport',
  DownloadCompletePurchasesReport = 'downloadCompletePurchasesReport',
  DownloadInvoicesReport = 'downloadInvoicesReport',
  DownloadInvoiceRevenueReport = 'downloadInvoiceRevenueReport',
  GenerateConsolidatedPurchasesReport = 'generateConsolidatedPurchasesReport',
  GeneratePurchaseReport = 'generatePurchaseReport',
  GetReportedPurchases = 'getReportedPurchases',
  GetAdminTransactions = 'getAdminTransactions',
  UpdateReportedPurchase = 'updateReportedPurchase',
  RequestAdditionalReview = 'requestAdditionalReview',
  ResetOpr = 'resetOpr',
  DownloadPurchaseReceipt = 'downloadPurchaseReceipt',
  DeleteUserStripeCustomer = 'deleteUserStripeCustomer',
  UpdateUserCountry = 'updateUserCountry',
  GetUserAllowances = 'getUserAllowances',
  AddUserAllowance = 'addUserAllowance',
  GetUserRecurringAllowances = 'getUserRecurringAllowances',
  AddUserRecurringAllowance = 'addUserRecurringAllowance',
  UpdateUserRecurringAllowance = 'updateUserRecurringAllowance',
  DeleteUserRecurringAllowance = 'deleteUserRecurringAllowance',
  GetEligibleSpend = 'getEligibleSpend',
  CreateBenefitProgram = 'createBenefitProgram',
  UpdateBenefitProgram = 'updateBenefitProgram',
  GetBenefitProgramCategories = 'getBenefitProgramCategories',
  AddProgramToMerchant = 'addProgramToMerchant',
  RemoveMerchantFromAllowList = 'removeMerchantFromAllowList',
  RemoveMerchantFromBlockList = 'removeMerchantFromBlockList',
  GetMerchants = 'getMerchants',
  GetMerchantCategories = 'getMerchantCategories',
  AssociateMerchantCategory = 'associateMerchantCategory',
  DisassociateMerchantCategory = 'disassociateMerchantCategory',
  AddMerchant = 'addMerchant',
  ResetRenewDate = 'resetRenewDate',
  TerminateEmployer = 'terminateEmployer',
  ResendPendingInvites = 'resendPendingInvites',
  BenefitProgramReceiptsDownload = 'benefitProgramReceiptsDownload',
  PayWithPrepaidInvoice = 'payWithPrepaidInvoice',
  UpdateBenefitProgramPolicy = 'updateBenefitProgramPolicy',
  EndBenefitProgramPolicy = 'endBenefitProgramPolicy',
  GetBenefitProgramMerchants = 'getBenefitProgramMerchants',
  GetActiveEmployersList = 'getActiveEmployersList',
  CreateEmployer = 'createEmployer',
  CreateEmployerCountry = 'createEmployerCountry',
  DeleteEmployerCountry = 'deleteEmployerCountry',
  CreateFeeSchedule = 'createFeeSchedule',
  UpdateFeeSchedule = 'updateFeeSchedule',
  DeleteFeeSchedule = 'deleteFeeSchedule',
  CreateMetaField = 'createMetaField',
  UpdateMetaField = 'updateMetaField',
  DeleteMetaField = 'deleteMetaField',
  UpdatePricingDescription = 'updatePricingDescription',
  MarkInvoiceComplete = 'markInvoiceComplete',
  BulkGenerateInvoices = 'bulkGenerateInvoices',
  GenerateCheckinReports = 'generateCheckinReports',
  RemoveStripeInvoiceId = 'removeStripeInvoiceId',
  RefreshTransactions = 'refreshTransactions',
  GetAdminAccountDetails = 'getAdminAccountDetails',
  CheckPlaidTokenStatus = 'checkPlaidTokenStatus',
  ForceUpdateMode = 'forceUpdateMode',
  AddPurchaseForUser = 'addPurchaseForUser',
  BulkCreatePurchases = 'bulkCreatePurchases',
  GetJoonCategories = 'getJoonCategories',
  CreateJoonCategory = 'createJoonCategory',
  UpdateJoonCategory = 'updateJoonCategory',
  DeleteJoonCategory = 'deleteJoonCategory',
  GetPlaidCategories = 'getPlaidCategories',
  AssociatePlaidCategory = 'associatePlaidCategory',
  DisassociatePlaidCategory = 'disassociatePlaidCategory'
}

enum SSOQueries {
  AddDomain = 'addDomain',
  DeleteDomain = 'deleteDomain',
  ToggleSSOForDomain = 'toggleSSOForDomain',
  CreateOrg = 'createOrg',
  LoginOptions = 'loginOptions'
}

export const QueryNames = {
  ...GeneralQueries,
  ...UserQueries,
  ...EmployerQueries,
  ...JOONAdminQueries,
  ...SSOQueries
}
export type QueryNames = typeof QueryNames
